var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsPays({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4349 15.8619L56.5258 8.09594C50.2471 -0.870946 41.2433 -2.37305 32.203 3.95703L8.52973 20.5332C-0.510772 26.8635 -2.17863 35.8379 4.01996 44.6905L17.5545 64.0198C23.753 72.8721 32.7567 74.3743 41.7972 68.044L65.4704 51.4678C74.5107 45.1378 76.1787 36.1632 69.9802 27.3109L69.4036 26.4873L58.3127 34.2533C53.1652 37.8576 46.1238 36.6826 42.5855 31.6293C39.0471 26.5761 40.3515 19.5577 45.4989 15.9534L45.4349 15.8619ZM48.1898 19.7963L57.3234 13.4009C58.4044 12.644 59.8832 12.8908 60.6261 13.9519L65.3032 20.6314C66.0301 21.6962 65.7584 23.1578 64.6913 23.9234L55.7674 30.172C53.1856 32.031 49.6805 31.8749 47.3445 29.7969C45.9655 28.4574 45.2634 26.5704 45.4264 24.6413C45.5893 22.7126 46.6008 20.9391 48.1898 19.7963ZM53.5031 26.5416L54.3653 25.9379C55.472 25.163 55.7522 23.6541 54.9915 22.5677C54.2308 21.4812 52.717 21.2285 51.6103 22.0035L50.7482 22.6071C50.2147 22.9716 49.8464 23.5308 49.7258 24.1597C49.6052 24.7886 49.7419 25.4351 50.1059 25.9544C50.8691 27.045 52.384 27.3067 53.5031 26.5416ZM16.5191 36.1089L31.3148 25.7489C32.4215 24.974 32.702 23.4649 31.9413 22.3785C31.1805 21.292 29.6665 21.0395 28.5598 21.8144L13.7642 32.1744C12.6665 32.943 12.3801 34.4354 13.1218 35.5219C13.8851 36.6122 15.3999 36.8739 16.5191 36.1089Z",
    fill: "url(#paint0_linear_4264_7176)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_7176",
    x1: -20.5281,
    y1: 40.8797,
    x2: 31.3721,
    y2: 115.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsPays);
export default __webpack_public_path__ + "static/media/stats-pays.2d82213d90cae640d9202a5ff7ae7d59.svg";
export { ForwardRef as ReactComponent };